import { render } from "./VZModal.vue?vue&type=template&id=79e3fced&ts=true"
import script from "./VZModal.vue?vue&type=script&lang=ts"
export * from "./VZModal.vue?vue&type=script&lang=ts"

import "./VZModal.vue?vue&type=style&index=0&id=79e3fced&lang=css"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__